import React from 'react';
import NumberInput from '../NumberInput/NumberInput';
import { FieldHookConfig, useField } from 'formik';

type NumberFieldProps = Partial<{ suffix: string }> & FieldHookConfig<number | string>;

const NumberField = ({ suffix, ...props }: NumberFieldProps) => {
    const [field, , helpers] = useField<number | string>(props);

    return (
        <NumberInput
            {...field}
            onChange={(e, value) => {
                field.onChange(e);
                helpers.setValue(value);
            }}
            onBlur={(e, value) => {
                field.onBlur(e);
                helpers.setValue(value);
            }}
        />
    );
};

export default NumberField;
